type NotificationData = { contentId?: string; orderId?: string; userId?: string };

/**
 * Maps backend notification actionUrl (user-app paths) to admin dashboard paths.
 * When actionUrl is missing, derives path from notification type + data.
 */
export function getDashboardNotificationPath(
  actionUrl: string | undefined,
  data?: NotificationData,
  type?: string,
): string | undefined {
  // 1) Use actionUrl when present
  if (actionUrl && typeof actionUrl === 'string') {
    const path = actionUrl.replace(/^\s+|\s+$/g, '');
    if (path) {
      if (path.startsWith('/dashboard')) return path;
      const contentMatch = path.match(/^\/content(?:\/([a-zA-Z0-9_-]+))?\/?$/);
      if (contentMatch) {
        const id = contentMatch[1] || data?.contentId;
        return id ? `/dashboard/content/edit/${id}` : '/dashboard/content';
      }
      if (path.startsWith('/diary/calendar-events')) return '/dashboard/diary/calendar-events';
      if (path === '/settings/billing' || path.startsWith('/settings/billing')) return '/dashboard/invoices';
      if (path.startsWith('/oracle-reading')) return '/dashboard/oracle-reading';
      return path.startsWith('/') ? `/dashboard${path}` : `/dashboard/${path}`;
    }
  }

  // 2) Fallback: derive from type + data when actionUrl is missing
  if (type) {
    switch (type) {
      case 'CONTENT_PUBLISHED':
        return data?.contentId ? `/dashboard/content/edit/${data.contentId}` : '/dashboard/content';
      case 'NEW_USER_REGISTERED':
        return '/dashboard/users';
      case 'DEEPER_ORACLE_READING_PURCHASED':
        return '/dashboard/oracle-reading';
      case 'EVENT_CREATED':
      case 'EVENT_REMINDER':
      case 'EVENT_STARTED':
        return '/dashboard/diary/calendar-events';
      case 'PAYMENT_FAILED':
      case 'PAYMENT_SUCCESS':
      case 'SUBSCRIPTION_RENEWED':
      case 'SUBSCRIPTION_EXPIRING':
        return '/dashboard/invoices';
      case 'ORACLE_READING_READY':
        return '/dashboard/oracle-reading';
      case 'ADMIN_ANNOUNCEMENT':
        return '/dashboard/notifications';
      default:
        return '/dashboard/notifications';
    }
  }

  return undefined;
}
